.dataGrid {
    width: 100%;
    flex-grow: 1;
}

.dataGridContainer {
    display: flex;
    height: calc(100vh - 280px);
}